<script lang="ts">
	import CopyToClipboardButton from '$lib/components/CopyToClipboardButton.svelte';
	import ShareButton from './ShareButton.svelte';
	import type { Snippet } from 'svelte';

	type Props = {
		url: string;
		hideOpen?: boolean;
		class?: string;
		left?: Snippet;
	};

	let { url, hideOpen = false, class: klass = '', left }: Props = $props();
</script>

<div class={`flex ${klass}`}>
	{@render left?.()}
	<div class="">
		<div>
			<span class="select-all break-all pr-3 tracking-tight text-violet-700" data-testid="link-url">{url}</span>
			<div class="mt-2">
				{#if !hideOpen}
					<a
						href={url}
						target="_blank"
						title="Öffentlichen Event Link öffnen"
						class="btn-secondary mr-2 inline-block px-2 py-1 text-xs"
					>
						<svg
							width="1em"
							height="1em"
							viewBox="0 0 16 16"
							class="bi bi-box-arrow-up-right mb-1 mr-1 inline"
							fill="currentColor"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
							/>
							<path
								fill-rule="evenodd"
								d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
							/>
						</svg>
						Öffnen
					</a>
				{/if}
				<ShareButton {url} classs="mr-4" />

				<CopyToClipboardButton textToCopy={url} title="Link kopieren" class="btn-secondary inline-block">
					Kopieren
				</CopyToClipboardButton>
			</div>
		</div>
	</div>
</div>
